import {
  PushMessageTopic as PMT,
  ServerToClientMessages,
} from 'mapistry-shared';
import { useThrottledOnArgsMessageHandler } from '../webSocket';

type OnFormTemplateProcessedMessage =
  ServerToClientMessages[PMT.FormTemplateGenerated];

/**
 * We want to call a specific callback when this notification comes in,
 * and the notification can only be triggered by a user interaction, and we tell the user to keep that tab open.
 * Thus not registering this listener globally, but for ease only on the required page.
 */
export function useFormTemplateGeneratedFromPdfMessageHandlers(
  onMessage: OnFormTemplateProcessedMessage,
) {
  useThrottledOnArgsMessageHandler(PMT.FormTemplateGenerated, (props) =>
    onMessage({
      formTemplate: props.formTemplate,
      error: props.error,
      tabIdentifier: props.tabIdentifier,
    }),
  );
}
